module.exports = __webpack_public_path__ + "img/External-connections.2b908683.png";